import { ref } from "vue";
import { defineStore } from "pinia";
import CryptoJS from "crypto-js";

const SECRET_KEY =
  process.env.VUE_APP_PINIA_SECRET_KEY || "vIDOjgyxQRzH9Izb81lMhqhMUY9F6CWw";

const key = "organisations";

export const useOrganisationsStore = defineStore(
  key,
  () => {
    // state

    const organisations = ref(null);
    const selectedOrganisation = ref(null);

    // actions

    const setOrganisations = (value) => {
      organisations.value = value;
    };

    const unsetOrganisations = () => {
      organisations.value = null;
    };

    const setSelectedOrganisation = (value) => {
      selectedOrganisation.value = value;
    };

    const unsetSelectedOrganisation = () => {
      selectedOrganisation.value = null;
    };

    return {
      organisations,
      selectedOrganisation,
      setOrganisations,
      unsetOrganisations,
      setSelectedOrganisation,
      unsetSelectedOrganisation,
    };
  },
  {
    persist: {
      key,
      storage: localStorage, // localStorage or sessionStorage
      serializer: {
        serialize: (value) =>
          CryptoJS.AES.encrypt(JSON.stringify(value), SECRET_KEY).toString(),
        deserialize: (value) => {
          const bytes = CryptoJS.AES.decrypt(value, SECRET_KEY);
          const decrypted = bytes.toString(CryptoJS.enc.Utf8);
          return JSON.parse(decrypted);
        },
      },
    },
  },
);
